export const COLOURS = {
    defaultStyle: {
        className: 'defaultStyle',
        primary: '#6F777C',
        secondary: '#2D353B',
        tertiary: '#FFFFFF'
    },
    redStyle: {
        className: 'redStyle',
        primary: '#911111',
        secondary: '#F29EAC',
        tertiary: '#9307A2'
    },
    tealStyle: {
        className: 'tealStyle',
        primary: '#0D4647',
        secondary: '#FAF5D8',
        tertiary: '#08997C'
    },
    purpleStyle: {
        className: 'purpleStyle',
        primary: '#6A32B3',
        secondary: '#FFD8B3',
        tertiary: '#C42B9E'
    },
    blueStyle: {
        className: 'blueStyle',
        primary: '#101E6D',
        secondary: '#BD6AE3',
        tertiary: '#FFFB01'
    },
    greenStyle: {
        className: 'greenStyle',
        primary: '#2F5E37',
        secondary: '#B9FBEE',
        tertiary: '#0068F1'
    },
    orangeStyle: {
        className: 'orangeStyle',
        primary: '#CB5800',
        secondary: '#F3DB99',
        tertiary: '#7E61FF'
    }
}